export const ChatPing = {
  mounted() {
    this.handleEvent("chat-ping", () => {
      const audio = document.getElementById("chat-ping-audio");
      if (!audio) return;
      // Browsers may reject .play() if no prior user gesture.
      // Swallow the error silently.
      const p = audio.play();
      if (p && typeof p.catch === "function") {
        p.catch(() => {});
      }
    });
  }
};
